import { render, staticRenderFns } from "./Trivia12.vue?vue&type=template&id=5b570e36&"
import script from "./Trivia12.vue?vue&type=script&lang=js&"
export * from "./Trivia12.vue?vue&type=script&lang=js&"
import style0 from "./Trivia12.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports